<template>
    <b-modal id="modal-agendar-horario" size="xl" hide-footer centered title="SOLICITAÇÃO" @hidden="limparFormulario()">
        <b-form class="d-flex flex-column justify-content-around p-1 gap-sm">
            <b-form-row>
                <b-col md="8" sm="12">
                    <label>Funcionário:</label>
                    <input v-model="agendamento.funcionario" type="text" class="form-control" placeholder="Nome Completo do Funcionário">
                </b-col>
                <b-col md="4" sm="12">
                    <label>CPF:</label>
                    <input v-model="agendamento.cpf" type="text" class="form-control" v-mask="'###.###.###-##'" placeholder="000.000.000-00">
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col md="6" sm="12">
                    <label>Cargo:</label>
                    <input v-model="agendamento.cargo" type="text" class="form-control" placeholder="Cargo">
                </b-col>
                <b-col md="2" sm="12">
                    <label>CBO:</label>
                    <input v-model="agendamento.cbo" type="text" class="form-control" placeholder="00.00-00" v-mask="'##.##-##'">
                </b-col>
                <b-col md="4" sm="12">
                    <label>Período:</label>
                    <select v-model="agendamento.periodo" class="form-control">
                        <option selected value disabled>Selecione</option>
                        <option value="Manhã">Manhã</option>
                        <option value="Tarde">Tarde</option>
                    </select>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col md="6" sm="12">
                    <label>Exame:</label>
                    <select v-model="agendamento.idExame" class="form-control">
                        <option selected value disabled>Selecione</option>
                        <option v-for="(e,index) in exames" :key="index" :value="e.id">{{ e.tipoExame }}</option>
                    </select>
                </b-col>
            </b-form-row>
            <div class="d-flex flex-column flex-md-row gap-sm mt-5 justify-content-between">
                <span class="text-left w-75" style="color: gray;">
                    * A solicitação de agendamento será analisada e em breve retornaremos o horário e dia do atendimento. Acompanhe as informações pela página <strong>Agendamento.</strong>
                </span>
                <b-button variant="outline-success" :disabled="carregando" @click.prevent="salvarNovoAgendamento()">
                    <span v-show="!carregando">
                        Agendar
                    </span>
					<b-spinner v-show="carregando" variant="success"></b-spinner>
                </b-button>
            </div>
        </b-form>

    </b-modal>
</template>

<script>
import SolicitacaoAgendamento from "../../model/SolicitacaoAgendamento.js";
import AgendamentoService from "../../service/AgendamentoService.js";
import TipoExameService from "../../service/TipoExameService.js";

export default {
	name: "ModalAgendarHorario",
	data() {
		return {
			carregando: false,
			agendamento: new SolicitacaoAgendamento(),
			exames: [],
		};
	},
	created() {
		this.listarTiposExame();
	},
	methods: {
		listarTiposExame() {
			TipoExameService.listar()
				.then((res) => {
					this.exames = res.data;
				}).catch((err) => {
					console.log(err);
				});
		},
		salvarNovoAgendamento() {
			this.carregando = true;

			if (this.formularioEhValido()) {
				const form = this.passaDadosNovoAgendamento();

				AgendamentoService.salvar(form)
					.then(() => {
						this.$emit("success");
					})
					.then(() => {
						this.$bvModal.hide("modal-agendar-horario");
					})
					.catch((err) => {
						console.log(err);
						if (err.response) {
							this.mensagem(err.response.data, "Aviso", "danger");
						} else {
							this.mensagem("Não foi possível realizar o agendamento do exame nesse momento", "Aviso", "danger");
						}
					})
					.finally(() => {
						this.carregando = false;
					});
			} else {
				this.carregando = false;
			}
		},
		passaDadosNovoAgendamento() {
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			const form = {
				idUsuarioResponsavel: usuarioLogado.id,
				funcionario: this.agendamento.funcionario,
				cpf: this.$options.filters.removeMascara(this.agendamento.cpf),
				cargo: this.agendamento.cargo,
				cbo: this.$options.filters.removeMascara(this.agendamento.cbo),
				periodo: this.agendamento.periodo,
				idExame: this.agendamento.idExame,
			};

			return form;
		},
		limparFormulario() {
			this.agendamento = new SolicitacaoAgendamento();
		},
		formularioEhValido() {
			if (
				!this.agendamento.funcionario
                || !this.agendamento.cpf
                || !this.agendamento.cargo
                || !this.agendamento.cbo
                || !this.agendamento.periodo
                || !this.agendamento.idExame
			) {
				this.mensagem("Todos os campos são obrigatórios!", "Aviso", "danger");
				return false;
			} else {
				return true;
			}
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/Agendamento/ModalAgendarHorario.vue